// extracted by mini-css-extract-plugin
export default {"swal-button--confirm":"App_swal-button--confirm__NFvUe","swal-footer":"App_swal-footer__-z4ly","root":"App_root__nZZtU","container":"App_container__4L7Vo"};